export const statelocalstorage = (state) => {

    const blackList = [
        'personEntries',
        'vehicleEntries',
        'people',
        'vehicles',
        'clients',
        'loaded',
        'mail',
        'otherClients',
    ];

    const whiteList = [
        'accessPoint',
        'client',
        'currentMenu',
        'menuOptions',
        'shift',
        'user',
        'currentEvaluatedUser',
        'currentEvaluation',
    ];



    // const toStoreState = {...state};
    const toStoreState = Object.assign({}, ...whiteList.map(key => ({[key]: state[key]})));

    // blackList.forEach(key => delete toStoreState[key]);

    // localStorage.setItem('state', LZString.compress(JSON.stringify(toStoreState)));
    try {

        localStorage.setItem('state', JSON.stringify(toStoreState));
    } catch (error) {
        console.log(error);
    }
}
